import DecodableContentProviderLogo from "./DecodableContentProviderLogo";

export default DecodableContentProviderLogo;
